import script from "./SectionAi.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionAi.vue?vue&type=script&setup=true&lang=js"

import "./SectionAi.vue?vue&type=style&index=0&id=8f8c3e9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f8c3e9e"]])

export default __exports__